export default {"src":"/minerva/_next/static/media/spinner.9b696139.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};